// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import firebase from 'firebase'
import vuefire from 'vuefire'
import product from './components/product'

Vue.component('product', product)

Vue.use(vuefire)
Vue.prototype.$firebase = firebase.initializeApp({
  apiKey: 'AIzaSyAVJ9U-qk0XznMTMXW93lvxN30_IN3DkEY',
  authDomain: 'decov-99610.firebaseapp.com',
  databaseURL: 'https://decov-99610.firebaseio.com',
  projectId: 'decov-99610',
  storageBucket: 'decov-99610.appspot.com',
  messagingSenderId: '514429420736'
})

Vue.use(Vuetify)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App, product }
})



// WEBPACK FOOTER //
// ./src/main.js